import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-co-up-right",
  "use": "icon-co-up-right-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-corner-up-right\" id=\"icon-co-up-right\"><polyline points=\"15 14 20 9 15 4\" /><path d=\"M4 20v-7a4 4 0 0 1 4-4h12\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol